import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_FULL = "https://customer-assets.emergentagent.com/job_cddf07d6-5f1e-4052-a01d-cb0eb2f121b4/artifacts/dl69yfkz_Full-logo-tagline.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-its-teal-dark border-t border-its-teal-light/20">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img src={LOGO_FULL} alt="It's IT" className="h-16 w-auto" />
            </Link>
            <p className="text-its-offwhite/80 text-sm leading-relaxed max-w-md">
              It's IT specializes in websites and web content management systems
              for small businesses and non-profits. We bring vibe coding to life
              with smarter, faster web solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-its-gold font-semibold mb-4 text-sm uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { label: "About", url: "/about" },
                { label: "Services", url: "/services" },
                { label: "News & Views", url: "/news" },
                { label: "The Process", url: "/process" },
                { label: "Contact", url: "/contact" },
              ].map((link) => (
                <li key={link.url}>
                  <Link
                    to={link.url}
                    className="text-its-offwhite/80 hover:text-its-gold text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-its-gold font-semibold mb-4 text-sm uppercase tracking-wider">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-its-offwhite/80 text-sm">
                <Phone size={16} className="text-its-teal-light" />
                <a href="tel:602-835-7541" className="hover:text-its-gold transition-colors">
                  602-835-7541
                </a>
              </li>
              <li className="flex items-start gap-3 text-its-offwhite/80 text-sm">
                <Mail size={16} className="text-its-teal-light mt-0.5" />
                <a href="mailto:info@itsittech.com" className="hover:text-its-gold transition-colors">
                  info@itsittech.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-its-teal-light/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-its-offwhite/60 text-sm">
              © {currentYear} It's IT. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/monkey"
                className="text-its-offwhite/60 hover:text-its-gold text-sm transition-colors"
              >
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
